module.exports = "https://static.zego.com/_next/static/images/UsageRateIcon-16b666aa3809ca80d97dc7372ddc06f6.svg";